import "@fontsource/fredoka/latin-600.css";
import "@fontsource/fredoka/latin-700.css";
import "@fontsource/lato/latin-400.css";
import "@fontsource/lato/latin-700.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { AppProviders } from "@/app/providers/app-providers";
import { router } from "@/app/router/router";
import { initializeGoogleTagManager } from "@/shared/analytics/analytics";
import { runtimeConfig } from "@/shared/config/runtime-config";
import { initializeThemePreference } from "@/shared/theme/theme-preference";
import "@/app/styles/global.css";

initializeGoogleTagManager(runtimeConfig.googleTagManagerId);
initializeThemePreference();

const root = document.querySelector("#root");
if (!root) throw new Error("Application root element was not found.");

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
